import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class StorageService {
    private languageIdStorageKeyName = 'azavista-registration-website-language-id';
    private storage = window.localStorage;
    private sessionStorage = window.sessionStorage;

    setPermanentStorage(storage: Storage): void {
        this.storage = storage;
    }

    getLanguage(): string {
        return this.getItem(this.languageIdStorageKeyName);
    }

    storeLanguage(languageId: string): void {
        this.setItem(this.languageIdStorageKeyName, languageId);
    }

    removeLanguage(): void {
        this.removeItem(this.languageIdStorageKeyName);
    }

    setItem(key: string, value: any): void {
        this.storage.setItem(key, JSON.stringify(value));
    }

    getItem(key: string): any {
        const value = this.storage.getItem(key);
        if (value === undefined) {
            return undefined;
        }
        if (value === '') {
            return '';
        }
        return JSON.parse(value);
    }

    removeItem(key: string): void {
        this.storage.removeItem(key);
    }

    setSessionItem(key: string, value: any): void {
        this.sessionStorage.setItem(key, JSON.stringify(value));
    }

    getSessionItem(key: string): any {
        return JSON.parse(this.sessionStorage.getItem(key));
    }

    removeSessionItem(key: string): void {
        this.sessionStorage.removeItem(key);
    }
}
